import React from 'react';
import { CircularProgress } from '@mui/material';
import './SubtleLoader.css';

interface SubtleLoaderProps {
    size?: number;
    sx?: any;
}

const SubtleLoader: React.FC<SubtleLoaderProps> = ({ size = 40, sx = {} }) => {
    return (
        <div className="loader-container">
            <CircularProgress size={size} sx={sx} />
        </div>
    );
};

export default SubtleLoader;
